import { render } from "./RedoVariant.vue?vue&type=template&id=40819e5b"
import script from "./RedoVariant.vue?vue&type=script&lang=js"
export * from "./RedoVariant.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/RedoVariant.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40819e5b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40819e5b', __exports__)) {
    api.reload('40819e5b', __exports__)
  }
  
  module.hot.accept("./RedoVariant.vue?vue&type=template&id=40819e5b", () => {
    api.rerender('40819e5b', render)
  })

}


export default __exports__